import { useEffect, useState } from 'react'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { Footer } from '../../components/Footer/Footer'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import dateAndTimeIcon from '../../images/DateAndTimeIcon.svg'
import { Alert, AlertTitle, Box, SelectChangeEvent, useMediaQuery } from '@mui/material'
import { container, flexcol, flexItemCenter, root } from '../../global'
import { useNavigate, useParams } from 'react-router-dom'
import {
  availableTimeSlots,
  bookTimeSlots,
  bookedSlotsPerDate,
  eventDetail,
  getBooking,
  selectedSlotRoomId
} from '../../services/EventService'
import moment from 'moment'
import { appTheme } from '../../theme'
import SeriesEvents from './SeriesEvents'
import { Message } from '../../components/Message/Message'
import { EventTitle } from '../../components/EventTitle/EventTitle'
import { EventDateAndTime } from './EventDateAndTime'
import { ProcessingDialog } from '../../components/InfoDialogs'
import { EventType, Role } from '../../services/Types'
import { validateDryRunDate } from '../../services/Helper'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

var isWebView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, '96px', 10, '96px') }
    : { padding: theme.spacing(0, 4, 10, 4) }
)

const convertTimeIntoMinutes = (time: string) => {
  if (time === '') {
    return 0
  }
  let timeArray = time.split(' ')
  let timeStr = timeArray[0]
  let timePMAM = timeArray[1]
  let timeMinutesArray = timeStr.split(':')
  let hours = timeMinutesArray[0]
  let minutes = timeMinutesArray[1]
  let totalMinutes = 0
  if (timePMAM === 'AM') {
    totalMinutes = Number(hours) * 60 + Number(minutes)
  } else if (timePMAM === 'PM' && Number(hours) === 12) {
    totalMinutes = Number(hours) * 60 + Number(minutes)
  } else {
    totalMinutes = Number(hours) * 60 + Number(minutes) + 12 * 60
  }
  return totalMinutes
}
const convertMinutesIntoTime = (time: number) => {
  if (time === 0) {
    return 0
  }
  let period = 'AM'
  let hours = Math.floor(time / 60)
  let minutes: any = Math.floor(time % 60)
  if (minutes === 0) {
    minutes = '00'
  }
  if (hours > 11) {
    period = 'PM'
  }
  if (hours > 12) {
    hours = hours - 12
  }
  let timeSlot = `${hours}:${minutes} ${period}`
  return timeSlot
}

export default function DateAndTimesPage() {
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))
  const updateWorkingDays = (date: Date, updateInDays: number) => {
    if (updateInDays >= 0) {
      for (var i = 0; i < updateInDays; i++) {
        date.setDate(date.getDate() + 1)
        if (date.getDay() === 0) {
          date.setDate(date.getDate() + 1)
        } else if (date.getDay() === 6) {
          date.setDate(date.getDate() + 2)
        }
      }
    } else {
      updateInDays = Math.abs(updateInDays)
      for (var num = 0; num < updateInDays; num++) {
        date.setDate(date.getDate() - 1)
        if (date.getDay() === 0) {
          date.setDate(date.getDate() - 2)
        } else if (date.getDay() === 6) {
          date.setDate(date.getDate() - 1)
        }
      }
    }
    return date.getDate()
  }

  let { id } = useParams()
  const [showErrorMessage, setErrorMessage] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')
  const [event, setEvent] = useState<any>({})
  const [audience, setAudience] = useState(0)

  // Time Picker logics
  // State variable of time Slots
  const [selectedLiveSlot, setLiveSlot] = useState<string>('')
  const [selectedDrySlot, setDrySlot] = useState<string>('')
  const [serialEvents, setSerialEvents] = useState<any[]>([])
  const [isSerialEvent, setSerialEvent] = useState(false)
  const [liveSlotsPerDate, setLiveSlotsPerDate] = useState({})
  const [drySlotsPerDate, setDrySlotsPerDate] = useState({})

  // Handle Click on time Slot
  const clickLiveSlot = (slot: any) => {
    setErrorMessage(false)
    setLiveSlot(slot)
  }
  const clickDrySlot = (slot: any) => {
    setErrorMessage(false)
    setDrySlot(slot)
  }

  // Live Event Run Logic start
  const [liveDuration, setLiveDuration] = useState(30)
  const [liveTimeSlots, setLiveTimeSlots] = useState<string[]>([])
  const [eventLiveDate, setEventLiveDate] = useState<Date | null>(
    () => new Date()
  )
  let minimumLiveDate = new Date()
  minimumLiveDate!.setDate(updateWorkingDays(minimumLiveDate!, 10))

  // Event Dry Run Logic start
  const [dryDuration, setDryDuration] = useState(30)
  const [dryTimeSlots, setDryTimeSlots] = useState<string[]>([])
  const [eventDryDate, setEventDryDate] = useState<Date | null>(
    () => new Date(eventLiveDate!)
  )

  const [isLoading, setLoading] = useState(true)
  const [isLoadingSeries, setLoadingSeries] = useState(true)

  var minimumDryDate = new Date()
  minimumDryDate!.setDate(updateWorkingDays(minimumDryDate!, 3))

  var maximumDryDate = new Date(eventLiveDate!)
  maximumDryDate!.setDate(updateWorkingDays(maximumDryDate!, -3))

  const [bookingCount, setBookingCount] = useState(0)
  const [bookingLoading, setBookingLoading] = useState(true)

  useEffect(() => {
    let bookingData = {
      'eventId': id,
      'dryDuration': dryDuration,
      'selectedDrySlot': selectedDrySlot,
      'eventDryDate': eventDryDate,
      'liveDuration': liveDuration,
      'selectedLiveSlot': selectedLiveSlot,
      'eventLiveDate': eventLiveDate,
    }
    let bookingDataStr = JSON.stringify(bookingData);
    localStorage.setItem('bookingData', bookingDataStr);
  }, [dryDuration, liveDuration, selectedDrySlot, selectedLiveSlot])

  const saveBookingDataToLocalStorage = (dryDuration: any, selectedDrySlot: any, eventDryDate: any, liveDuration: any, selectedLiveSlot: any, eventLiveDate: any) => {
    let bookingData = {
      'eventId': id,
      'dryDuration': dryDuration,
      'selectedDrySlot': selectedDrySlot,
      'eventDryDate': eventDryDate,
      'liveDuration': liveDuration,
      'selectedLiveSlot': selectedLiveSlot,
      'eventLiveDate': eventLiveDate,
    }
    let bookingDataStr = JSON.stringify(bookingData);
    localStorage.setItem('bookingData', bookingDataStr);
  }

  useEffect(() => {
    setEventDryDate(minimumDryDate!)
  }, [])

  const getNextAvailableDate = (date: Date | null, duration: number) => {
    if (!date) return null
    const blockedDates = getBlockedDates('live', duration)

    let minimumDate = moment(minimumLiveDate)
    let currentDate = moment(date)
    if (currentDate.isBefore(minimumDate)) currentDate = minimumDate
    while (true) {
      if (!blockedDates.includes(currentDate.format('YYYY-MM-DD'))) break
      currentDate = currentDate.add(currentDate.day() === 5 ? 3 : 1, 'day')
    }

    return currentDate.toDate()
  }

  const handleLiveDuration = async (event: SelectChangeEvent) => {
    if (+event.target.value === liveDuration) return

    setErrorMessage(false)
    setLiveDuration(parseInt(event.target.value))
    setLiveSlot('')
    setEventLiveDate(getNextAvailableDate(eventLiveDate, +event.target.value))
    await getTimeSlots(Number(event.target.value), 'live')
  }

  const handleDryDuration = async (event: SelectChangeEvent) => {
    if (+event.target.value === dryDuration) return

    setErrorMessage(false)
    setDryDuration(parseInt(event.target.value))
    setDrySlot('')
    await getTimeSlots(Number(event.target.value), 'dry')
  }

  const displayServerError = () => {
    setValidationMessage('Internal server error')
    showErrorPopup()
  }

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            if (data.eventDetail.data === null) {
              return navigate('/')
            }
            if (data.eventDetail.data.creater.id !== user.id && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            if (data.eventDetail.data.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            let liveRoomBooking = data.eventDetail.data.roomBooking?.find((x: any) => x.category === 'live')
            if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            setEvent(data.eventDetail.data)
            if (data.eventDetail.data.eventType !== EventType.SERIES) {
              setLoadingSeries(false)
            }
            setAudience(data.eventDetail.data.overHundredParticipants ? 3000 : 500)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    const bookingLoad = async () => {
      try {
        setBookingLoading(true)
        setBookingCount(0)

        const { data } = await getBooking(Number(id))
        if (data) {
          if (data.booking.statusCode === 200) {
            const booking = data.booking.data
            if (booking[0]?.category === 'live') {
              setEventLiveDate(
                new Date(
                  new Date(Number(booking[0].date)).toISOString().slice(0, -1)
                )
              )
              setLiveDuration(booking[0].endTime - booking[0].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[0].startTime
              )
              setLiveSlot(bookingSelectedStartTime)
            }
            if (booking[0]?.category === 'dry') {
              setEventDryDate(
                new Date(
                  new Date(Number(booking[0].date)).toISOString().slice(0, -1)
                )
              )
              setDryDuration(booking[0].endTime - booking[0].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[0].startTime
              )
              setDrySlot(bookingSelectedStartTime)
            }

            if (booking[1]?.category === 'live') {
              setEventLiveDate(
                new Date(
                  new Date(Number(booking[1].date)).toISOString().slice(0, -1)
                )
              )
              setLiveDuration(booking[1].endTime - booking[1].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[1].startTime
              )
              setLiveSlot(bookingSelectedStartTime)
            }
            if (booking[1]?.category === 'dry') {
              setEventDryDate(
                new Date(
                  new Date(Number(booking[1].date)).toISOString().slice(0, -1)
                )
              )
              setDryDuration(booking[1].endTime - booking[1].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[1].startTime
              )
              setDrySlot(bookingSelectedStartTime)
            }

            saveBookingDataToLocalStorage(dryDuration, selectedDrySlot, eventDryDate, liveDuration, selectedLiveSlot, eventLiveDate);
            setLoading(false)
          }
          
          setBookingLoading(false)
          setBookingCount(data.booking.data.length)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    if (id !== undefined) {
      loadEventData()
      bookingLoad()
    }
  }, [])

  useEffect(() => {
    const loadBookedSlotsPerDate = async (eventId: number, category: string) => {
      try {
        const { data } = await bookedSlotsPerDate(eventId, { audience, category })
  
        if (data.bookedSlotsPerDate.statusCode === 200) {
          if (category === 'live') setLiveSlotsPerDate(data.bookedSlotsPerDate.data)
          else setDrySlotsPerDate(data.bookedSlotsPerDate.data)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (audience) {
      getTimeSlots(liveDuration, 'live')
      getTimeSlots(dryDuration, 'dry')

      loadBookedSlotsPerDate(Number(id), 'live')
      loadBookedSlotsPerDate(Number(id), 'dry')
    }
  }, [audience, dryDuration, liveDuration])

  const showErrorPopup = () => {
    setErrorMessage(true)
    setTimeout(() => {
      setErrorMessage(false)
    }, 3000)
  }

  const getTimeSlots = async (duration: number, category: string) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(eventDryDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    try {
      const { data } = await availableTimeSlots(Number(id), input)
      if (data) {
        if (data.availableTimeSlots.statusCode === 200) {
          if (category === 'live') {
            setLiveTimeSlots(data.availableTimeSlots.data)
          }
          if (category === 'dry') {
            setDryTimeSlots(data.availableTimeSlots.data)
          }
        }
      }
    } catch (error) {
      displayServerError()
    }
  }

  useEffect(() => {
    if (!bookingLoading && bookingCount === 0) {
      setEventLiveDate(getNextAvailableDate(eventLiveDate, liveDuration))
    }
  }, [bookingLoading, liveSlotsPerDate])

  useEffect(() => {
    getTimeSlots(Number(liveDuration), 'live')
  }, [eventLiveDate])

  useEffect(() => {
    getTimeSlots(Number(dryDuration), 'dry')
  }, [eventDryDate])

  // Validate and clear dry run date if it becomes invalid when live event date changes
  useEffect(() => {
    // Skip validation during initial booking load to prevent clearing valid existing dates
    if (bookingLoading) {
      return
    }

    const isValid = validateDryRunDate(eventLiveDate, eventDryDate, updateWorkingDays)
    
    // Only clear if explicitly invalid (false), not if null (can't validate)
    if (isValid === false) {
      setEventDryDate(null)
      setDrySlot('')
    }
  }, [eventLiveDate, eventDryDate, bookingLoading])

  const getSelectedSlotRoomId = async (
    selectedSlot: string,
    duration: number,
    category: string
  ) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(eventDryDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    let slotRoomId: any = 0

    try {
      const { data } = await selectedSlotRoomId(selectedSlot, Number(id), event.eventType, input)
      if (data) {
        if (data.selectedSlotRoomId.statusCode === 200) {
          if (category === 'live') {
            slotRoomId = data.selectedSlotRoomId.data.slotRoomId
          }
          if (category === 'dry') {
            slotRoomId = data.selectedSlotRoomId.data.slotRoomId
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
    return slotRoomId
  }

  const navigate = useNavigate()

  const backClick = async () => {
    if (event.eventType === 'Webinar') navigate('/event/audience/' + Number(id))
    else if (event.eventType === EventType.SERIES) navigate('/event/featuresAndRequests/' + Number(id))
    else navigate('/event/staff/' + Number(id))
  }

  const nextClick = async () => {
    // no live/dry times saved for a series master event
    if (event.eventType === EventType.SERIES) {
      if (serialEvents.length === 0) {
        setValidationMessage('Please add at least one event to the series')
        showErrorPopup()
        return
      }
      if (event.eventType === EventType.SERIES) navigate('/event/review/' + Number(id))
      else navigate('/event/featuresAndRequests/' + Number(id))
      return
    }
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) {
      setValidationMessage('Please select live duration')
      showErrorPopup()
      return
    }
    if (liveStartTime === 0) {
      setValidationMessage('Please select live start time')
      showErrorPopup()
      return
    }
    if (dryDuration === 0) {
      setValidationMessage('Please select dry duration')
      showErrorPopup()
      return
    }
    if (dryStartTime === 0) {
      setValidationMessage('Please select dry start time')
      showErrorPopup()
      return
    }
    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(eventDryDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let dryRoomId = await getSelectedSlotRoomId(
        selectedDrySlot,
        dryDuration,
        'dry'
      )
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) {
        setValidationMessage('Live Event room not available')
        showErrorPopup()
        return
      }
      if (dryRoomId === 0) {
        setValidationMessage('Dry Event room not available')
        showErrorPopup()
        return
      }

      let seriesEventError = ''
      for (let i = 0; i < serialEvents.length; i++) {
        if (serialEvents[i].id !== Number(id)) {
          let roomBookings = serialEvents[i].roomBooking
          let liveData = roomBookings.find((x: any) => x.category === 'live')
          if (!liveData) {
            seriesEventError = 'Please provide live dates for series events'
            break
          }
          let dryData = roomBookings.find((x: any) => x.category === 'dry')
          if (!dryData) {
            seriesEventError = 'Please provide dry run dates for series events'
            break
          }
        }
      }

      if (seriesEventError) {
        setValidationMessage(seriesEventError)
        showErrorPopup()
        return
      }

      const { data } = await bookTimeSlots(
        liveRoomId,
        dryRoomId,
        Number(id),
        input
      )
      if (data) {
        if (data.bookTimeSlots.statusCode === 200) {
          navigate('/event/featuresAndRequests/' + event.id)
        } else if (data.bookTimeSlots.statusCode === 404) {
          setValidationMessage(data.bookTimeSlots.message)
          showErrorPopup()
        } else {
          setValidationMessage('Internal server error')
          showErrorPopup()
        }
      } else {
        setValidationMessage('Internal server error')
        showErrorPopup()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const makeSeriesEvent = async (setSerialEvent: any) => {
    // no live/dry times saved for a series master event
    if (event.eventType === EventType.SERIES) {
      setSerialEvent(true)
      return
    }
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) {
      setValidationMessage('Please select live duration')
      showErrorPopup()
      return
    }
    if (liveStartTime === 0) {
      setValidationMessage('Please select live start time')
      showErrorPopup()
      return
    }
    if (dryDuration === 0) {
      setValidationMessage('Please select dry duration')
      showErrorPopup()
      return
    }
    if (dryStartTime === 0) {
      setValidationMessage('Please select dry start time')
      showErrorPopup()
      return
    }
    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(eventDryDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let dryRoomId = await getSelectedSlotRoomId(
        selectedDrySlot,
        dryDuration,
        'dry'
      )
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) {
        setValidationMessage('Live Event room not available')
        showErrorPopup()
        return
      }
      if (dryRoomId === 0) {
        setValidationMessage('Dry Event room not available')
        showErrorPopup()
        return
      }
      const { data } = await bookTimeSlots(
        liveRoomId,
        dryRoomId,
        Number(id),
        input
      )
      if (data) {
        if (data.bookTimeSlots.statusCode === 200) {
          setSerialEvent(true)
          //navigate('/featuresAndRequests/' + event.id)
        } else if (data.bookTimeSlots.statusCode === 404) {
          setValidationMessage(data.bookTimeSlots.message)
          showErrorPopup()
        } else {
          setValidationMessage('Internal server error')
          showErrorPopup()
        }
      } else {
        setValidationMessage('Internal server error')
        showErrorPopup()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveExit = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) return navigate('/')
    if (liveStartTime === 0) return navigate('/')
    if (dryDuration === 0) return navigate('/')
    if (dryStartTime === 0) return navigate('/')

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(eventDryDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }
    try {
      let dryRoomId = await getSelectedSlotRoomId(
        selectedDrySlot,
        dryDuration,
        'dry'
      )
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) return navigate('/')
      if (dryRoomId === 0) return navigate('/')

      await bookTimeSlots(liveRoomId, dryRoomId, Number(id), input)

      navigate('/')
    } catch (error) {
      navigate('/')
    }
  }

  const saveMainBooking = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) return
    if (liveStartTime === 0) return
    if (dryDuration === 0) return
    if (dryStartTime === 0) return

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(eventDryDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let dryRoomId = await getSelectedSlotRoomId(
        selectedDrySlot,
        dryDuration,
        'dry'
      )
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) return
      if (dryRoomId === 0) return

      await bookTimeSlots(liveRoomId, dryRoomId, Number(id), input)
    } catch (error) {
      console.log(error)
    }
  }

  const removeSerialEvent = (eventId: number) => {
    setSerialEvents(serialEvents.filter(x => x.id !== eventId))
  }

  const getBlockedDates = (category: string, duration?: number) => {
    let blockedDates: string[] = []

    if (category === 'live') {
      Object.entries(liveSlotsPerDate).forEach((x: any) => {
        if (!x[1][duration || liveDuration]) blockedDates.push(x[0])
      })
    } else {
      Object.entries(drySlotsPerDate).forEach((x: any) => {
        if (!x[1][duration || dryDuration]) blockedDates.push(x[0])
      })
    }

    return blockedDates
  }

  return (
    <Box style={root}>
      <ProgressBar
        activePageTitle='Date & Times'
        requestType={event.eventType}
      />
      <Item sx={{ bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <EventTitle title={event.title} />

        <Box
          style={container}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Grid
            container
            style={flexcol}
            sx={{
              maxWidth: '934px',
              justifyContent: 'center',
              padding: '32px !important',
              paddingBottom: '8px',
              background: '#FFFFFF',
              gap: '32px',
              borderRadius: '32px',
              marginTop: '32px',
              marginBottom: '32px'
            }}
          >
            {showErrorMessage && (
              <Grid item xs={12} sm={12} md={12} style={flexItemCenter}>
                {showErrorMessage && (
                  <Message message={validationMessage} isError={true} />
                )}
              </Grid>
            )}
            {/* Page Title */}
            <Grid item sm={12} sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box
                sx={{
                  height: '40px',
                  width: '40px',
                  background: 'rgba(0, 107, 215, 0.1)',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: '16px'
                }}
              >
                <Box
                  component='img'
                  src={dateAndTimeIcon}
                  alt='Date and Time Icon'
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography align='left' variant='h5'>
                  Date & Times
                </Typography>
              </Box>
            </Grid>
            {/* Event Calendar */}
            {event.eventType !== EventType.SERIES ? (
            <>
              {/* Live Event Date */}
              <EventDateAndTime
                eventName={'Event'}
                minimumDate={minimumLiveDate}
                eventDate={eventLiveDate!}
                duration={liveDuration}
                setEventDate={setEventLiveDate}
                setLiveSlot={setLiveSlot}
                handleDuration={handleLiveDuration}
                selectedSlot={selectedLiveSlot}
                availableSlots={liveTimeSlots}
                clickSlot={clickLiveSlot}
                blockedDates={getBlockedDates('live')}
                faqDate={
                  <>
                    <Typography display='inline'>
                      Live events must be scheduled 10 business days in advance
                      to ensure the success of your event.
                    </Typography>
                    <Typography display='inline' sx={{ fontWeight: '600' }}>
                      {' '}
                      If you must schedule an event within 10 business days
                    </Typography>
                    <Typography display='inline'>
                      , select a compliant date and time on this page, and
                      provide your desired date and time on the
                    </Typography>
                    <Typography display='inline' sx={{ fontWeight: '600' }}>
                      {' '}
                      Features & Requests
                    </Typography>
                    <Typography display='inline'> page.</Typography>
                  </>
                }
                faqTime='Available start times are based on your date selection in the step above. If a start time is not displayed, that time slot is unavailable. All times are presented in the Eastern Time Zone.'
              />

              {/* DRY RUN */}

              <EventDateAndTime
                eventName={'Event Dry Run'}
                minimumDate={minimumDryDate}
                maximumDate={maximumDryDate}
                eventDate={eventDryDate!}
                duration={dryDuration}
                setEventDate={setEventDryDate}
                setDrySlot={setDrySlot}
                handleDuration={handleDryDuration}
                selectedSlot={selectedDrySlot}
                availableSlots={dryTimeSlots}
                clickSlot={clickDrySlot}
                blockedDates={getBlockedDates('dry')}
                faqDate='Dry Runs are required and must be scheduled at least 2 days before your live event. Dry Runs are required for you, your presenters, and your moderator to become comfortable with the technology, clarify speaking roles, and review outstanding items as a group. A Dry Run is especially helpful when your presenters or moderator are new to conducting a webinar with ETA, or you plan interactive features (e.g. polling, video streaming, etc.) during the webinar.'
                faqTime='Available start times are based on your dry run date selection in the step above. If a start time is not displayed, that time slot is unavailable. All times are presented in the Eastern Time Zone.'
              />
            </>
            ) : null}

            {event.eventType === EventType.SERIES && (
            <SeriesEvents
              isSerialEvent={isSerialEvent}
              setSerialEvent={setSerialEvent}
              setSerialEvents={setSerialEvents}
              setLoadingSeries={setLoadingSeries}
              makeSeriesEvent={makeSeriesEvent}
              saveMainBooking={saveMainBooking}
              removeSerialEvent={removeSerialEvent}
              eventType={event.eventType}
            />
            )}
          </Grid>
        </Box>

        <Footer
          saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Date & Times'
          canMoveNext={true}
        />
      </Item>

      <ProcessingDialog
        open={isLoading || isLoadingSeries}
        message='Loading...'
      />
    </Box>
  )
}
